import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { EmployeeSuspension, EmployeeSuspensionRequest } from 'src/app/models/employee-suspension.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PayrollService } from 'src/app/services/payroll.service';

interface SuspensionRequest {
    reason: string;
    suspensionDate: string;
    returnDate?: string;
    paidStatus?: number;
    type?: number;
}

@Component({
  selector: 'app-employee-suspensions',
  templateUrl: './employee-suspensions.component.html',
  styleUrls: ['./employee-suspensions.component.scss']
})
export class EmployeeSuspensionsComponent implements OnInit {
  suspensionRequest: SuspensionRequest = {
    reason: '',
    suspensionDate: ''
  }
  type: number = 0;
  allPersonal = []
  contractedPersonal = [];
  numberContracted = 0;
  saving = false;
  employeeSelected = null;

  startDate = '';
  endDate = null;
  searching = false;
  suspensions: EmployeeSuspension [] = [];
  editingItem: number | null = null;
  loading: { [key: number]: boolean } = {};

  constructor(
    private toastService: ToastrService,
    private payrollService: PayrollService
  ) {
    this.startDate = new Date().toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getContracted();
    this.getSuspensions();
  }

  getContracted() {
    this.payrollService.getContracted().subscribe({
      next: (response: ResponseObject) => {
        this.allPersonal = response.data;
        this.contractedPersonal = response.data;
        this.changeNumber();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getSuspensions() {
    const start = DateUtil.parseDateToMilliseconds(this.startDate);
    const end = this.endDate ? DateUtil.parseDateToMilliseconds(this.endDate) : null;

    this.searching = true;
    if (end) {
      this.payrollService.getSuspensionStartEnd(start, end).subscribe({
        next: (response: ResponseObject) => {
          this.suspensions = response.data;
          this.searching = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al buscar suspensiones: ");
        }
      })
    } else {
      this.payrollService.getSuspensionStart(start).subscribe({
        next: (response: ResponseObject) => {
          this.suspensions = response.data;
          this.searching = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al buscar suspensiones: ");
        }
      })
    }
  }

  filter(event: any) {
    this.contractedPersonal = this.allPersonal.filter((p) => {
      return (p.identificacion + " " + p.nombre).toLowerCase().includes(event.target.value.toLowerCase())
    });
  }

  setSelected(employee: any) {
    if (this.employeeSelected && this.employeeSelected === employee.id) {
      this.employeeSelected = null;
    } else
      this.employeeSelected = employee.id;
  }

  changeNumber() {
    var selected = 0;
    this.allPersonal.forEach((c) => {
      selected += c['selected'] ? 1 : 0;
    });
    this.numberContracted = selected;
  }

  reset() {
    // this.newExtraPayment = new ExtraPaymentRequest();
    this.contractedPersonal = [];
    this.allPersonal = [];
    this.numberContracted = 0;
    this.type = 0;
    this.getContracted();
    this.getSuspensions();
  }

  createSuspension() {
    if (this.suspensionRequest.suspensionDate == '' || !this.suspensionRequest.paidStatus ||
      !this.suspensionRequest.type || this.suspensionRequest.reason == '' || !this.employeeSelected) {
      return;
    }

    const request: EmployeeSuspensionRequest = {
      employee: this.employeeSelected,
      reason: this.suspensionRequest.reason,
      suspensionDate: DateUtil.parseDateToMilliseconds(this.suspensionRequest.suspensionDate),
      returnDate: this.suspensionRequest.returnDate && this.suspensionRequest.returnDate!='' ? DateUtil.parseDateToMilliseconds(this.suspensionRequest.returnDate) : null,
      paidStatus: this.suspensionRequest.paidStatus,
      type: this.suspensionRequest.type,
    }
    this.saving = true;

    this.payrollService.createSuspension(request).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Suspensión creada con exito!");
        this.employeeSelected = null;
        this.saving = false;
        this.reset();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.saving = false;
      }
    })
  }

  startEditing(itemId: number) {
    this.editingItem = itemId;
  }

  setEndDate(item: EmployeeSuspension, newDate: string) {
    if (!newDate) {
      return;
    }
    const request: any = {
      endDate: DateUtil.parseDateToMilliseconds(newDate)
    };

    this.payrollService.updateEndDateSuspension(item.id, DateUtil.parseDateToMilliseconds(newDate)).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Fecha de retorno actualizada con exito!");
        this.editingItem = null;
        this.getSuspensions();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
